import { render } from "./StudentResultSummary.vue?vue&type=template&id=7c7ccf6f&ts=true"
import script from "./StudentResultSummary.vue?vue&type=script&lang=ts"
export * from "./StudentResultSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__